const content: { [key: string]: string } = {
  performanceBonus: "Performance Bonus",
  csi: "CSI+",
  watchlist: "Watchlist",
  performance: "Performance",
  earlyIncentives: "Early Incentives",
  myGroup: "My Group",
  leaderGrowth: "Leader Growth",
  resources: "Resources",
  monthlyPerformance: "Monthly Performance",
  annualPerformance: "Annual Performance",
  earningsCalculator: "Earnings Calculator",
  bronzeFoundation: "Bronze Foundation+",
  bronzeBuilder: "Bronze Builder+",
  cml: "CML",
  los: "LOS",
  edlos: "EDLOS",
  groupManagementDashboard: "Group Management",
  actionReports: "Action Reports",
  performancePlusElite: "PPE+",
  performancePlus: "Performance Plus+",
  performanceElite: "Performance Elite+",
  personalGrowthAnnual: "Annual Personal Group Growth+",
  personalGrowthMonthly: "Monthly Personal Group Growth+",
  personalGroupGrowth: "Personal Group Growth+",
  frontlineGrowth: "Frontline Growth Incentive+",
  frontlineQ: "Frontline Q+",
  leadershipPlus: "Leadership Plus+",
  twoTimeCashIncentive: "TTCI+",
  feedback: "Provide Us Feedback",
  learnAboutCpp: "Learn About Core Plus+",
  hat: "HAT/GAR",
  faa: "FAA",
  customerMemberList: "Customer Member List",
  newAboActivation: "Path to Bronze+",
  bronzeGroupTracking: "Bronze Group Tracking",
  mbi: "MBI",
  strongStartIncentive: "Strong Start Incentive+",
  bronzeIncentives: "Bronze Incentives",
  qcg: "QCG+",
  leadershipSeminar: "Leadership Seminar",
  leadershipSeminarEsan: "Leadership Training Seminar",
  visionBonus: "Vision Bonus+",
  monthlyQ: "Monthly Q1/QV+",
  qGrowthIncentive: "Q Growth Incentive+",
  healthWellbeing: "Health and Wellbeing Bonus+",
  annualq: "Annual Q+",
  ssiUplineReport: "SSI+ Upline Report",
  diamondBonus: "A70 100+ Diamond Bonus+",
  pathToA70: "Path to A70+",
  a70EliteBonus: "A70 Elite Bonus+",
  onlineStatements: "Online Statements",
  retroPvInquiry: "Return/Retro PV Inquiry Report",
  whosNew: "Who's New",
  whosNewWithCustomers: "New ABO/PC Activity",
  foundersSalesIncentive: "Founders Sales Incentive{symbol}",
};

export default content;
